import { BlurFade } from '@/components/ui/blur-fade'
import { ImagePlaceholder } from './ImagePlaceholder'
import { PillButton } from './PillButton'

export function FinalCtaSection() {
  return (
    <section className="relative overflow-hidden">
      {/* Background image placeholder — group practice space at golden hour */}
      <ImagePlaceholder
        label="Wide group practice space at golden hour (full-bleed background)"
        rounded="rounded-none"
        className="absolute inset-0 h-full w-full border-0"
      />
      {/* Legibility overlay */}
      <div className="absolute inset-0 bg-cream/80" />

      <div className="relative mx-auto max-w-[720px] px-6 py-24 text-center lg:py-32">
        <BlurFade>
          <h2 className="text-4xl font-bold text-gray-900 sm:text-5xl">
            Start your loop.
          </h2>
        </BlurFade>
        <BlurFade delay={0.1}>
          <p className="mx-auto mt-5 max-w-lg text-lg leading-relaxed text-gray-700">
            Begin where you are. Move, breathe, reflect, connect. Make wellness
            part of your everyday life.
          </p>
        </BlurFade>
        <BlurFade delay={0.2}>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <PillButton to="/events" variant="primary">
              Explore experiences →
            </PillButton>
            {/* TODO: replace with real WhatsApp community invite link */}
            <PillButton href="#community" variant="secondary">
              Join the community
            </PillButton>
          </div>
        </BlurFade>
      </div>
    </section>
  )
}
